<div class="mb-3">
  <div class="row mt-3 mb-4">
    <div class="col-12 responsive">
      <iframe id="purchase" [src]="urlSafe" frameborder="0" width="100%" height="100%"></iframe>
    </div>
  </div>
</div>
